module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "head"
  }, [_vm._v("商户管理后台")]), _vm._v(" "), _c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.userType),
      callback: function($$v) {
        _vm.userType = $$v
      },
      expression: "userType"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "商户",
      "name": "merchant"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "收银员",
      "name": "cash"
    }
  })], 1), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userType === 'merchant'),
      expression: "userType === 'merchant'"
    }],
    ref: "merchant",
    attrs: {
      "model": _vm.merchant,
      "rules": _vm.merchantRules
    }
  }, [_c('el-form-item', {
    staticClass: "username",
    attrs: {
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "text",
      "placeholder": "注册账号"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.onEnter($event)
      }
    },
    model: {
      value: (_vm.merchant.username),
      callback: function($$v) {
        _vm.$set(_vm.merchant, "username", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "merchant.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "password",
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "password",
      "placeholder": "6位以上"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.onEnter($event)
      }
    },
    model: {
      value: (_vm.merchant.password),
      callback: function($$v) {
        _vm.$set(_vm.merchant, "password", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "merchant.password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-header-btn panel-header-btn__fill",
    on: {
      "click": _vm.login
    }
  }, [(_vm.loading) ? _c('span', {
    staticClass: "el-icon-loading"
  }) : _c('span', [_vm._v("登录")])])], 1), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userType === 'cash'),
      expression: "userType === 'cash'"
    }],
    ref: "cash",
    attrs: {
      "model": _vm.cash,
      "rules": _vm.cashRules
    }
  }, [_c('el-form-item', {
    staticClass: "username",
    attrs: {
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "text",
      "placeholder": "主账号"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.onEnter($event)
      }
    },
    model: {
      value: (_vm.cash.name),
      callback: function($$v) {
        _vm.$set(_vm.cash, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "cash.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "cashier",
    attrs: {
      "prop": "opuid"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "text",
      "placeholder": "收银员编号"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.onEnter($event)
      }
    },
    model: {
      value: (_vm.cash.opuid),
      callback: function($$v) {
        _vm.$set(_vm.cash, "opuid", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "cash.opuid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "password",
    attrs: {
      "prop": "pass"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "password",
      "placeholder": "6位以上"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.onEnter($event)
      }
    },
    model: {
      value: (_vm.cash.pass),
      callback: function($$v) {
        _vm.$set(_vm.cash, "pass", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "cash.pass"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-header-btn panel-header-btn__fill",
    on: {
      "click": _vm.login
    }
  }, [(_vm.loading) ? _c('span', {
    staticClass: "el-icon-loading"
  }) : _c('span', [_vm._v("登录")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('router-link', {
    staticClass: "forget",
    attrs: {
      "to": {
        name: 'forget'
      }
    }
  }, [_vm._v("忘记密码?")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72b2e3ff"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/login.vue
// module id = 831
// module chunks = 1